import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import "./order.less";
import { setActiveSidebar } from "states/app-setting/app-setting.action";
import { globalValueSetLoading } from "states/global-value/global-value.action";
import { OrderModel } from "states/order/order.models";
import { getOrderApi } from "states/order/order.api";
import { useParams } from "react-router-dom";
import { formatMoney, vnMoneyToNumber } from "shared/plugins/string-helper";
import { OrderStatusComponent } from "./order-status";
import { PaymentStatusComponent } from "./payment-status";
interface RouteProps {
  orderId: string;
}
const OrderDetail = () => {
  const dispatch = useDispatch();
  const params = useParams<RouteProps>();
  const [model, setModel] = useState<OrderModel>({} as OrderModel);
  const getOrder = async () => {
    dispatch(globalValueSetLoading(true));
    const result = await getOrderApi(params.orderId);
    setModel(result.data);
    dispatch(globalValueSetLoading(false));
  };
  useEffect(() => {
    dispatch(setActiveSidebar("order"));
    getOrder();
  }, []);
  return (
    model ? (
      <React.Fragment>
        <div className="head">
          Thông tin đơn hàng - {`#${model.orderNumber}`}{" "}
         
        </div>
        <div className="content-order">
          <div className="content-detail">
            <div className="item">
              <div className="title">Thông tin giao hàng</div>
              <div className="content-info">
                <div className="name text-bold">{model.shipName}</div>
                <div className="address">
                  {`${model.address}${`, ${model.wardName}`}, ${
                    model.districtName
                  }, ${model?.provinceName}`}
                </div>
                <div className="phone">Số điện thoại : {model.shipPhoneNumber}</div>
                <div className="phone">Họ và tên người mua : {model.name}</div>
                <div className="phone">Số điện thoại người mua : {model.phoneNumber}</div>
                <div className="email">Địa chỉ email: {model.email}</div>
              </div>
            </div>
            <div className="item">
              <div className="title">Trạng thái đơn hàng</div>
              <div className="content-info">
                <p>
                  <strong>Trạng thái thanh toán:</strong> {" "}
                  <PaymentStatusComponent paymentStatus={model?.paymentStatus} />
                </p>
                <p>
                  <strong>Trạng thái đơn hàng:</strong> {" "}
                  <OrderStatusComponent orderStatus={model?.orderStatus} />
                </p>
              </div>
            </div>
          </div>
          <div className="products hidden-xs">
            <table>
              <thead>
                <tr>
                  <th>Sản phẩm</th>
                  <th>Đơn giá</th>
                  <th style={{textAlign:"center"}}>Số lượng</th>
                  <th>Tạm tính</th>
                </tr>
              </thead>
              <tbody>
                {model?.orderItems?.map((model) => (
                  <tr>
                    <td>
                      <div className="product-info">
                        <div className="img-container">
                          <img src={model.skuImage} width={50} alt="" />
                        </div>
                        <div className="name">
                          <span>{model.skuName}</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span className="price">
                        {formatMoney(model.price / model.quantity)}
                      </span>
                    </td>
                    <td style={{textAlign:"center"}}>{model.quantity}</td>
                    <td>
                      <span className="price">
                        {formatMoney(model.price)}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={3}>Tạm tính</td>
                  <td>{formatMoney(model.subTotalAmount)}</td>
                </tr>
                <tr>
                  <td colSpan={3}>Phí ship</td>
                  <td>{formatMoney(model.shippingFee)}</td>
                </tr>
                <tr>
                  <td colSpan={3}>Giảm giá</td>
                  <td>{formatMoney(model.discountAmount)}</td>
                </tr>
                <tr>
                  <td colSpan={3}>Thành tiền</td>
                  <td>
                    <span className="sum">
                      {formatMoney(model.totalAmount)}
                    </span>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div className="order-mobile visible-xs">
            {model?.orderItems?.map((model) => (
              <div className="item-product">
                <div className="product-info">
                  <div className="img-container">
                    <img src={model.skuImage} width="50" alt="" />
                  </div>
                  <div className="name">
                    <span>
                      {model.skuName} x {model.quantity}
                    </span>
                    <div className="name-list"></div>
                    <div className="total">
                      {formatMoney(model.price * model.quantity)}
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <div className="summary">
              <div className="item-summary">
                <div className="name">Tạm tính</div>
                <div className="price">
                  {formatMoney(model.subTotalAmount)}
                </div>
              </div>
              <div className="item-summary">
                <div className="name">Phí ship</div>
                <div className="price">
                  {formatMoney(model.shippingFee)}
                </div>
              </div>
              <div className="item-summary">
                <div className="name">Giảm giá</div>
                <div className="price">
                  {formatMoney(model.discountAmount)}
                </div>
              </div>
              <div className="item-summary">
                <div className="name">Thành tiền</div>
                <div className="price">
                  <span className="sum">
                    {formatMoney(model.totalAmount)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    ): null
  );
};
export default OrderDetail;
